var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star"},[(_vm.currentNum)?_c('ul',{staticClass:"star-items"},[_vm._l((_vm.currentNum),function(index){return _c('li',{staticClass:"star-item star-item-active",on:{"click":_vm.getIndex}})}),_vm._v(" "),_vm._l((5-_vm.currentNum),function(index){return _c('li',{staticClass:"star-item",on:{"click":_vm.getIndex}})})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a2ae90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/star/star.vue
// module id = null
// module chunks = 